module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Tips_Form":{"wrapMethods.submit":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101002},"path":"~.Tips_Form","_fox_":1}],"hooks.onStartSubmit":[{"value":function () {
var AutoLoginService = require('../components/auto-login')(fox);
var pm = this.rwom1('@root #permissionManager');
if (!pm.hasAccess('guestActual'))
return true;
if (!this.autoLoginService) {
this.autoLoginService = new AutoLoginService(this);
}
var autoLoginService = this.autoLoginService;
var objWithToken = autoLoginService.injectToken({});
var transactionParams = fox.merge({}, this.getOption('preparedTransactionParams'), {
'transitParams[token]': objWithToken.token
});
this.setOption('preparedTransactionParams', transactionParams);
return true;
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101018},"path":"~.Tips_Form","_fox_":1}],"showCbInPopup":[{"value":function (promise) {
var autoLoginService = this.autoLoginService;
var cbPopup = this.wom1('#cbPaymentPopup');
if (!cbPopup) {
cbPopup = this.embedWidget('cbPaymentPopup', 'CBPaymentPopup', {
matchTokenFunction: function (token) {
return autoLoginService ? autoLoginService.matchToken(token) : false;
}
});
cbPopup.run();
}
return cbPopup.show(promise.then(function (data) {
if (data === true) {
cbPopup.hide();
return data;
}
var url = data.submit_url + '?' + fox.toQueryString(data.added_fields);
return { url: url };
}));
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101039},"path":"~.Tips_Form","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/tipsPaymentInPopup.js
// module id = 738
// module chunks = 4